import invariant from 'tiny-invariant';

import { AccessRequestErrorBuilder } from './errorBuilder';
import { permissions } from './permissions';

/**
 * @param {{ workspace: *; allowPastDue?: boolean }} context Restriction context
 * @param {string} permission Rule to check in the format "<resource name>" [ ":" ("*" | "?" | "<action name>") ]
 * @param {* | ((error: AccessRequestError|undefined) => void)} [subjectOrCallback] Restriction subject
 * @param {(error: AccessRequestError|undefined, subject?: *) => void|false} [callback] If specified, callback would be called with the check error as first arg
 * @returns {AccessRequestError|null} Error if check fails
 */
export const checkRestrictions = (context, permission, subjectOrCallback, callback) => {
    invariant(!Array.isArray(permission), `Permission should not be an array, got "${permission}"`);

    let subject = subjectOrCallback;

    if (typeof subject === 'function') {
        callback = subject;
        subject = null;
    }

    const builder = new AccessRequestErrorBuilder(permissions, context).setPermission(permission);
    let error = null;

    if (subject && Array.isArray(subject)) {
        for (const item of subject) {
            const itemError = builder.setSubject(item).build();

            if (callback) {
                if (false !== callback(itemError, item)) {
                    error = itemError;
                    break;
                }
            } else if (itemError) {
                return itemError;
            }
        }

        if (callback) {
            callback(error);
        }
    } else {
        error = builder.setSubject(subject).build();

        if (callback) {
            callback(error, subject);
        }
    }

    return error;
};

export const checkRestrictionsOrThrow = (context, permission, subject) => {
    const error = checkRestrictions(context, permission, subject);

    if (error) {
        throw error;
    }
};
